import styled from '@emotion/styled';
import Button from '@mui/material/Button';

const SmallRadiusButtonStyle = styled(Button)`
  color: white !important;
  font-size: 24px !important;
  font-weight: bold !important;
  border-radius: 10px !important;
  padding: 0px 20px !important;
  min-width: 100px !important;
  height: 35px !important;
  line-height: 1.1 !important;
  text-transform: none !important;
`;

export default SmallRadiusButtonStyle;
